import { render, staticRenderFns } from "./OrderPayDone.vue?vue&type=template&id=13807e95&"
import script from "./OrderPayDone.vue?vue&type=script&lang=ts&"
export * from "./OrderPayDone.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports